import { Toggle } from '@simplywallst/ui-core';
import type { NarrativeForm } from '../utils/schema';
import { NarrativeValuatorTooltip } from '../components/NarrativeValuator/components/NarrativeValuatorTooltip';
import { tooltipContent } from '../components/NarrativeValuator/tooltipContent';

export const ShareholderToggleButton = ({
  values,
  onChange,
}: {
  values: NarrativeForm;
  onChange: (values: NarrativeForm) => void;
  userHoldsPosition: boolean;
}) => {
  return (
    <div className="grid grid-cols-[max-content_max-content] items-center">
      <Toggle
        label="I'm a shareholder"
        name="userHoldsPosition"
        value={values.userHoldsPosition ?? false}
        onChange={(e) =>
          onChange({
            ...values,
            userHoldsPosition: e.target.checked,
          })
        }
      />
      <NarrativeValuatorTooltip>
        {tooltipContent.userHoldsPosition}
      </NarrativeValuatorTooltip>
    </div>
  );
};
